import { EarthArrowLeftIcon } from './EarthArrowLeftIcon';

/**
 * author: frankgrinaert
 * id 01449F7D-91CD-46C4-A645-654860CEB1E0
 * name earth-arrow-left
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-arrow-left.svg
 * tags
 */
export const PlanetArrowLeftIcon = EarthArrowLeftIcon;
export default PlanetArrowLeftIcon